import { DATEFORMAT, CvDateFormatter } from '@cv-invision/cv.component-library.ux';

/**
 * Defines the columns
 * And any action against the columns
 */

export class NexsysOrderLogsColumnsModel {
	private _columns: Array<any>;
	constructor(dateService:CvDateFormatter) {
		this._columns = [
			{
				headerName: 'LogAction',
				field: 'action',
				width: 120
			},
			{
				headerName: 'Success',
				field: 'valid',
				width: 120
			},
			{
				headerName: 'Manual',
				field: 'forced',
				width: 120
			},
			{
				headerName: 'Http CodeResponse',
				field: 'httpStatusCodeResponse',
				width: 110
			},
			{
				headerName: 'Generated(Local)',
				field: 'created',
				valueFormatter: params => dateService.format(DATEFORMAT.EMPTY, params.data.created),
				width: 110
			},
			{
				headerName: 'Actions',
				width: 50,
				cellRenderer: 'customActionRetryCellComponent'
			}
		];
	}

	get columns(): Array<any> {
		return this._columns;
	}
}
